module.exports = __webpack_public_path__ + "img/icon-profile.122e8bd5.png";